module.exports = __webpack_public_path__ + "media/applicants/linkedin-f3f1b747.svg";